<template>
	<section class="container-fluid">
		<div class="offset-xl-3 col-xl-6 offset-md-2 col-md-8">
			<div class="row">
				<div class="col-12">
					<h1>Jobs</h1>
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<div class="row options-bar">
						<button class="add-item" @click="addOpen = true">Add Jobs <i class="ss-plus ss-glyphish-filled"></i></button>
						<Search v-on:foundItems="filteredList" defaultText="Search jobs" :items="jobs" />
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<List :jobs="foundJobs.length ? foundJobs : jobs" @edit="editJob" @delete="deleteJob"/>
				</div>
			</div>
			<Add v-if="addOpen" @close="addOpen = false"/>
			<Edit v-if="editOpen" @close="editOpen = false" :job="selected"/>
			<Delete v-if="deleteOpen" @close="deleteOpen = false" :job="selected"/>
		</div>
	</section>
</template>

<script>
import { mapState } from 'vuex'
import Search from '../Form/Search'
import List from '../Jobs/List.vue'
import Add from '../Jobs/Add.vue'
import Edit from '../Jobs/Edit.vue'
import Delete from '../Jobs/Delete.vue'

export default { 
	components: {
		List,
		Add,
		Edit,
		Delete,
		Search
	},
	data() {
		return {
			selected: null,
			deleteOpen: false,
			editOpen: false,
			addOpen: false,
			foundJobs: []
		}
	},
	computed : {
		...mapState({
			jobs: state => state.jobs.list
		})
	},
	methods: {
		deleteJob(job) {
			this.selected = job
			this.deleteOpen = true
		},
		editJob(job) {
			this.selected = job
			this.editOpen = true
		},
		filteredList(items) {
			if(items.length > 0) {
				this.foundJobs = items;
			} 
		}
	},
	mounted() {
		this.$store.commit('app/setLoading', true)
		const jobs = this.$store.dispatch('jobs/getList')

		Promise.all([jobs])
		.then(() => {
			this.$store.commit('app/setLoading', false);
		})
		.catch(err => {
			this.$store.commit('app/setLoading', false);
			this.$store.dispatch('app/addAlert', {
				type: 'error',
				message: 'An Error occurred, please try later',
				timeout: 3000
			})
		})
	}
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Pages/Jobs.vue